import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-back-button-component',
  standalone: true,
  templateUrl: './back-button-component.html',
  styleUrl: './back-button-component.css',
})
export class BackButtonComponent {
  private readonly location = inject(Location);

  goBack(): void {
    this.location.back();
  }
}
